// extracted by mini-css-extract-plugin
module.exports = {"blockBackgroundText":"blockBackgroundText-module--blockBackgroundText--4pkGD","blockBackgroundText__text":"blockBackgroundText-module--blockBackgroundText__text--2nssb"};